"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalBodyStyles = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _styledComponents = require("styled-components");
var _poppins = require("./poppins");
var _openSans = require("./open-sans");
var _colors = require("./colors");
var _fontWeights = require("./font-weights");
var _colorClasses = require("./color-classes");
var _templateObject;
var GlobalBodyStyles = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  body {\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n  }\n"])), _poppins.poppinsFont, _openSans.openSansFont, _colors.colors, _fontWeights.fontWeights, _colorClasses.colorClasses);
exports.GlobalBodyStyles = GlobalBodyStyles;